export const getOriginal = (image) => {
  return typeof image === 'string'
    ? image
    : image.src
      ? image.src
      : image.Url
        ? image.Url
        : null;
};

export const getThumbnail = (image) => {
  return typeof image === 'string'
    ? image
    : image.thumb
      ? image.thumb
      : image.thumbnail
        ? image.thumbnail
        : image.src
          ? image.src
          : image.Url
            ? image.Url
            : null;
};

